export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER = "UPDATE_USER";
export const CURRENT_USER = "CURRENT_USER";

export const TOGGLE = "TOGGLE";
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR";

export const CHANGE_POST = "CHANGE_POST";

export const CREATE_SOCKET = "CREATE_SOCKET";
export const SWITCH_POST  = "SWITCH_POST";
